"use strict";
/**
 * Represents the standard Insight API response, returned by every
 * Insight service.  The `data` property will contain the information
 * specific to any given API call.
 *
 * @export
 * @class InsightApiResponse
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightApiResponse = void 0;
class InsightApiResponse {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.InsightApiResponse = InsightApiResponse;
//# sourceMappingURL=InsightApiResponse.js.map